import { BookOpen, CodeXml, Mic, Microscope, type LucideIcon } from 'lucide-react'
import { PersonaType } from '@/store'

const ICONS: Record<Exclude<PersonaType, null>, LucideIcon> = {
  engineer: CodeXml,
  researcher: Microscope,
  speaker: Mic,
  educator: BookOpen,
}

interface PersonaIconProps {
  persona: Exclude<PersonaType, null>
  className?: string
}

/** Persona icon as an inline lucide SVG (replaces the emoji icons). */
export function PersonaIcon({ persona, className = 'h-5 w-5' }: PersonaIconProps) {
  const Icon = ICONS[persona]
  return <Icon className={className} aria-hidden="true" />
}
